













import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import { ThreadFirstPost } from "../../Classes/Entities/Chat/ThreadFirstPost";

@Component
export default class TalkThreadOverview extends Vue {
  @Prop() 
  public threadFirstPost!:ThreadFirstPost;
}
